<template>
<v-app class="report-calling">
    <v-app-bar app color="#00a699" class="nav-bar">
        <img src="../../static/images/leftbar_logo.png" alt="#" class="logo_sec" />
        <v-toolbar-title></v-toolbar-title>
        <v-spacer></v-spacer>
         <!-- User menu -->
        <v-btn text @click="logout" class="log-out-option">Logout</v-btn>
    </v-app-bar>
    <v-main class="main">
        <v-container  class="main-container">

            <v-row>
                <v-col>
                    <h1 class="form-heading  v-text-h1 v-font-weight-light v-text-center v-mb-4">Calling Report Form</h1>
                </v-col>
            </v-row>

            <v-row >
                <v-form  ref="form" class="custom-form pt-10 pb-8" @submit.prevent="validateAndSubmit">
                    <v-row>
                        <!-- Mode -->
                        <v-col cols="12" md="6" class="py-0">
                            <v-select v-model="formDetails.mode" label="Mode" :items="['Incoming', 'Outgoing']" :rules="[v => !!v || 'Please select a value']" class="margin"></v-select>
                        </v-col>
    
                        <!-- Client Code -->
                        <v-col cols="12" md="6" class="py-0">
                            <v-text-field v-model="formDetails.client_code" label="Client Code" :rules="[v => !!v || 'Client Code is required']" class="margin"></v-text-field>
                        </v-col>
    
                        <!-- Issues Dropdown -->
                        <v-col cols="12" md="6" class="py-0">
                            <v-select v-model="formDetails.issueId" label="Issues" :items="issues"  :item-props="itemProps"  @update:model-value="onIssueChange" class="form-element margin" :rules="[v => (v !== null) || 'Please select a value']" ></v-select>
                        </v-col>

                        <!-- Department Dropdown -->
                        <v-col cols="12" md="6" class="py-0">
                            <v-text-field v-model="formDetails.department" label="Department" class="form-element margin" :rules="[v => !!v || 'Department is required']" readonly></v-text-field>
                        </v-col>

                        <!-- Particulars Dropdown -->
                        <v-col cols="12" class="py-0">
                            <v-select v-model="formDetails.particulars" label="Particulars" :items="selectedIssue ? selectedIssue.particulars : []" :item-props="particularProps" class="form-element margin"  :rules="[v => (v !== null && v.length > 0) || 'Please select a value']"></v-select>
                        </v-col>

                        <!-- Status Dropdown -->
                        <v-col cols="12" md="4" class="py-0">
                            <v-select v-model="formDetails.status" label="Status" :items="['Pending', 'Resolved']"  class="form-element margin" :rules="[v => !!v || 'Please select a value']"></v-select>
                        </v-col>
    
                        <!-- IKF Dropdown -->
                        <v-col cols="12" md="4" class="py-0">
                            <v-select v-model="formDetails.IKF" label="IKF" :items="['Yes', 'No']"  class="form-element margin" :rules="[v => !!v || 'Please select a value']"></v-select>
                        </v-col>
    
                        <!-- RKF Dropdown -->
                        <v-col cols="12" md="4" class="py-0">
                            <v-select v-model="formDetails.REF" label="Reference" :items="['Yes', 'No']"  class="form-element margin" :rules="[v => !!v || 'Please select a value']"></v-select>
                        </v-col>
    
                         <!-- Remarks Textarea -->
                        <v-col cols="12" class="py-0">
                            <v-textarea v-model="formDetails.remarks" label="Remarks" rows="2"  class="form-element margin"></v-textarea>
                        </v-col>
    
                        <v-col cols="12" md="6" class="rating-stars-field form-element margin py-0">
                            <label class="rating-label" for="rating">Rating:</label>
                            <!-- Use the RatingStars component and bind it to a data property -->
                            <rating-stars v-model="formDetails.rating" :totalStars="5" />
                        </v-col>
                        <!-- Snackbar -->
                        <v-snackbar v-model="snackbar.show" :color="snackbar.color" rounded="pill"  :timeout="snackbar.timeout" class="snack-bar" :style="{ bottom: `100px` , padding: '10px'}" absolute bottom>
                            <div class="text-center ">{{ snackbar.message }}</div>
                        </v-snackbar>

                        <!-- Submit button -->
                        <v-col cols="12" class="submit-button py-0">
                            <v-btn type="button"  :loading="loading" @click="validateAndSubmit" class="form-element issue-submit">Submit</v-btn>
                        </v-col>
                    </v-row>
                </v-form>
            </v-row>
        </v-container>
    </v-main>

</v-app>
</template>

  
<script>
import RatingStars from './RatingStars.vue';
import axios from 'axios';

export default {
    // Existing code...
    name: "Calling-Form",
    data() {
        return {
            // drawer: false,
            // dialog: false,
            formDetails: {
                issueId: null,
                department: null,
                particulars: [],
                rating : 0,
                issues: '',
                status: 'Pending', // Default value for Status
                IKF: 'Yes',      // Default value for IKF
                REF: 'Yes',
                mode: 'Incoming',
                // Add other form fields...
            },
            issues: [],
            snackbar: {
                show: false,
                color: '',
                message: '',
                timeout: 3000, // Adjust the timeout as needed (in milliseconds)
            },
            selectedIssue: null,
            loading: false,
        };
    },
    created() {

       this.fetchFormData();
    },
  
    methods: {

        async fetchFormData() {
        
            const response = await axios.post('https://dev-admin-api.shoonya.com/api/getIssueList')
            const data = response.data.data;
            this.parseCSData(data);

        },
        itemProps (issues) {
            return {
                title: issues.name,
                value: issues.issueId,
            }
        },
        updateRating(rating) {
            this.formDetails.rating = rating;
        },
        particularProps (particulars) {
            return {
                title: particulars.name,
                value: particulars.name,
            }
        },
        showSnackbar(message, type) {
            this.snackbar.message = message;
            this.snackbar.color = type === 'success' ? 'success' : 'error';
            this.snackbar.show = true;
        },
        parseCSData(list) {
            
            let tempIssueTypes = [];
            list.forEach((issue) => {
                let issueIndex = tempIssueTypes.findIndex(
                (current) => current.value === issue.issueId
                );
                if (issueIndex === -1) {
                tempIssueTypes.push({
                    name: issue.name,
                    issueId: issue.issueId,
                    department: issue.department,
                    particulars: issue.particulars,
                });
                }
            });
            this.issues = [...tempIssueTypes];
            // this.setIssueTypes(this.issuesTypes);
        },
        logout() {

            // this.dialog = false;
            // Clear authentication data from local storage
            localStorage.removeItem('authToken');
            localStorage.removeItem('userDetails');

            // Redirect to the home page or login page if you have one
            this.$router.push('/');
        },
        onIssueChange() {
            this.selectedIssue = this.issues.find(issue => issue.issueId === this.formDetails.issueId);

            // Reset other related fields
            this.formDetails.department = this.selectedIssue ? this.selectedIssue.department.charAt(0).toUpperCase() + this.selectedIssue.department.slice(1) : null;
            this.formDetails.particulars = this.selectedIssue ? this.selectedIssue.particulars[0].name : null;
            this.formDetails.issues = this.selectedIssue ? this.selectedIssue.name : null;
            
        },
        async submitForm() {
            // Add logic to handle form submission
            await axios.post('https://dev-admin-api.shoonya.com/api/createOneEntryForIssue', this.formDetails)

            this.formDetails.rating = 0;

            this.$refs.form.reset();
            // const data = response.data.data;
            this.snackbar.timeout = 1000
            
            // console.log('Form Submit ted:', this.formDetails);
            this.showSnackbar('Form submitted successfully', 'success');

        },
        async validateAndSubmit() {

            const valid = await this.validateForm();

            if (valid.valid) {
                try {
                    this.loading = true;  
                    await this.submitForm();
                } catch (error) {
                    console.error('Error submitting form:', error);
                    this.showSnackbar('Form submission failed. Please try again.', 'error');
                } finally {
                    this.loading = false;  
                }

            } else {
                    console.log('Form is not valid. Please check the fields.');
                    this.showSnackbar('Form validation failed. Please check the fields', 'error');
            } 
            this.loading = false;
        },
        validateForm() {
            return new Promise(resolve => {
                this.$refs.form.validate().then(valid => {
                    resolve(valid);
                });
            });
        },

    },
    components: {
        RatingStars,
    }
};
</script>

<style>
        
    ::v-deep .v-snack__wrapper {
        min-width: 0px;
    }
    .report-calling {
        background-color: #f5f6f7; /* Light gray background color from Groww */
    }
    .nav-bar {
        background-color: #00a699; /* Yellowish background color from Groww */
    }
    .main-container {
        padding: 20px;
        max-height: calc(100vh - 64px);
        overflow-y: auto;
    }
    .main-container::-webkit-scrollbar {
        display: none;
    }
    .form-label {
        font-size: 16px;
        margin-bottom: 8px;
        color: #333; /* Adjust color as needed */
    }
    .log-out-option {
        color: #333;
        font-weight: bold;
        font-family: 'Sora';
    }
    .log-out-option:hover {
        background-color:#d6d8d95c;
        transition: box-shadow 0.3s ease; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
    .custom-form {
        max-width: 850px;
        margin: 0 auto;
        background-color:#e9ecef;
        padding: 20px;
        border-radius: 8px;
        transition: box-shadow 0.3s ease; 
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        margin-bottom: 20px;
    }
    .form-element v-btn {
        background-color: #00ab66; /* Green button color from Groww */
        color: #ffffff; /* White text color */
    }
    .custom-form:hover {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); /* Darker box shadow on hover */
    }
    .v-row {
        margin: 0; /* Remove default margin for cleaner appearance */
    }
    .form-element {
        margin-bottom: 16px;
    }
    .v-select, .v-text-field {
        margin-bottom: 16px;
    }
    .rating-label {
        font-size: 20px;
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        font-weight: bold;
        color: #333; 
    }
    .rating-stars-field {
        display: flex;
        align-items: end;
        grid-gap: 10px;
    }
    .form-element .v-btn,
    .custom-form .v-btn {
        background-color: #00ab66; /* Green button color */
        color: #ffffff; /* White text color */
    }

    .form-element .v-btn:hover,
    .custom-form .v-btn:hover {
        background-color: #009355; /* Darker green on hover */
    }
    .submit-button {
        display: flex;
        justify-content: center;
    }
    .issue-submit {
        font-size: 110% !important;
        font-weight: bold !important;
        margin: 10px !important;
        padding-top: 20px !important;
        padding-left: 20px !important;
        padding-bottom: 40px !important;
        padding-right: 20px !important;
        font-family: 'Sora';
    }
    .logo_sec {
        height: 50px;
        margin-left: 15px;
    }
    h1.form-heading {
        font-weight: bold;
        text-align: center;
        padding: 30px;
        font-size: 163%;
        letter-spacing: 0.1px;
        color: var(--browncolor);
    }
    .main {
        background: rgb(53 151 103 / 33%);
    }
    .margin {
        margin: 0 !important;
    }

</style>
